import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Top-left "← AI Marketplace" link shown across the agent surface.
 *
 * If `heroRef` is provided, the text color flips white-on-dark while the hero
 * is on screen, then black-on-light once scrolled past. Pages without a dark
 * hero omit the prop and render dark text on light bg.
 */
const MarketplaceBackLink = ({ heroRef }) => {
  const navigate = useNavigate();
  const [overDark, setOverDark] = useState(!!heroRef);

  useEffect(() => {
    if (!heroRef) return undefined;
    const update = () => {
      const el = heroRef.current;
      if (!el) return;
      setOverDark(el.getBoundingClientRect().bottom > 40);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [heroRef]);

  const fg = overDark ? '#fff' : '#0a0a0a';
  const textShadow = overDark
    ? '0 0 10px rgba(0,0,0,0.55), 0 0 18px rgba(0,0,0,0.35)'
    : '0 0 10px rgba(255,255,255,0.85), 0 0 18px rgba(255,255,255,0.6)';

  return (
    <>
      <style>{`
        .marketplace-back-link-fixed {
          transition: opacity 0.2s ease;
          opacity: 0.78;
        }
        .marketplace-back-link-fixed:hover { opacity: 1; }
      `}</style>
      <button
        type="button"
        onClick={() => navigate('/marketplace')}
        className="marketplace-back-link-fixed"
        style={{
          position: 'fixed',
          top: 18,
          left: 24,
          zIndex: 1000,
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          color: fg,
          textShadow,
          fontSize: '0.7rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          fontFamily: 'inherit',
        }}
      >
        &larr; AI Marketplace
      </button>
    </>
  );
};

export default MarketplaceBackLink;
